module.exports = __webpack_public_path__ + "img/ARG.46546d77.svg";